import React from "react";
import { Modal, Segment, List, Image } from "semantic-ui-react";
import { withRouter } from 'react-router-dom';
import btnClose from "../../semantic/dist/themes/fibrestream/assets/images/menu-close.svg";
import { connect } from "react-redux";
const BuidingsListModal = props => {
  const { open, closeModal, buildings } = props;

  return (
    <Modal
      open={open}
      onClose={closeModal}
      basic
      closeOnDimmerClick={false}
      className='modal__building-list'
      centered
    >

      <Segment inverted className="not-yet-avail w-400">
        <Modal.Header className="pt-5 pb-3"> <h3 className="bold text-white text-center">
          5000 Mbps is available at the following addresses.
          </h3></Modal.Header>
        <Modal.Content className="ui centered grid mx-0 my-5" scrolling>

          <List className="text-grey2 f-size--14">
            {
              buildings && buildings.map((building, index) => {
                return <List.Item key={index}>{building.address} {building.city}</List.Item>
              })
            }
          </List>
          <div className="close" onClick={closeModal}>
            <span className="times text-white cursor-pointer"><Image src={btnClose} verticalAlign='middle' /></span>
          </div>
        </Modal.Content>
      </Segment>

    </Modal>
  )
};

const mapStateToProps = state => {
  return {
    buildings: state.buildingsByServiceAvailable
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(BuidingsListModal)
);



// WEBPACK FOOTER //
// ./src/components/internet/BuidingsListModal.js